import { Skeleton } from '@mui/material'
import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'

export const PreLoading: React.FC = () => {
    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['']}>
                    <Skeleton
                        variant="text"
                        width={600}
                        height={60}
                        animation="wave"
                    />
                </ContentGuide.Header>
                <div className="w-full h-full flex justify-center items-center">
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="100%"
                        animation="wave"
                    />
                </div>
            </ContentGuide.Card>
        </ContentGuide>
    )
}
